var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('div',[_c('h1',[_vm._v("ABOUT")]),_c('div',[_vm._v(_vm._s(_vm.VUE_APP_API_DOMAIN))])])])}
var staticRenderFns = []

export { render, staticRenderFns }